module.exports = __webpack_public_path__ + "static/media/inquisitor_armor.4416831a.png";